import { BUYPOINT_NOTIFICATION } from "../action/Action";

const initialState = {
    notification: false
}

const buyPointNotificationReducer = (state = initialState, action) => {
    switch (action?.type) {
        case BUYPOINT_NOTIFICATION:
            return {
                ...state,
                notification: action?.payload
            };

        default:
            return state;
    }
}

export default buyPointNotificationReducer;